module.exports = __webpack_public_path__ + "img/icon_map_jght.0c20df9b.png";